export const THEME = {
  colors: {
    // Blue
    blue1: "#000080",

    // Grey
    grayLight: "#EAEAEA",
    grayMedium: "#d9d9da",
    silver: "#C0C0C0", // total/subtotal row background (EBITDA, Operating Profit, etc.)

    // Yellow
    yellowLight: "#ffffcc", // data-cell highlight
    yellowBanner: "#FFFF00", // "CURRENT MONTH" block header highlight
    creamYellow: "#EDEDCD", // data-cell highlight used on the Financial_Table (EBITDA / Net Profit) report

    // Red
    red: "#eb080b", // negative value text
    redBanner: "#FF0000", // section/category banner rows

    // Black / White
    black: "#000000",
    white: "#ffffff",

    // Border
    borderColor1: "#bfbfbf",

    // ── Waterfall / Budget_Actual_Chart palette (from screenshot color codes) ──
    increase: "#559BDB", // blue bars — value went up
    total: "#A8A8A8", // grey bars — start/end totals
    decrease: "#F77B29", // orange bars — value went down
    chartDarkBg: "#4F4F4F", // dark panel background behind each chart
  },
};